/**
 * src/config/index.js
 *
 * Central client configuration. Only client-safe values live here (Appendix B).
 * The demo-to-live flip itself is a SERVER-side flag (USE_DATABASE); the client
 * simply asks the API what mode it is in via /system-health and degrades
 * gracefully to curated demo data on any fault (Section 4 & 8).
 */

const env = import.meta.env;

export const config = {
  appName: env.VITE_APP_NAME || 'HemaAI',
  appVersion: env.VITE_APP_VERSION || '2.0.0',
  appUrl: env.VITE_APP_URL || window.location.origin,

  // Base path for the serverless API tier.
  apiBase: env.VITE_API_BASE || '/.netlify/functions',

  // Publishable identifiers only.
  supabaseUrl: env.VITE_SUPABASE_URL || '',
  supabaseAnonKey: env.VITE_SUPABASE_ANON_KEY || '',
  stripePublishableKey: env.VITE_STRIPE_PUBLISHABLE_KEY || '',

  features: {
    telemedicine: env.VITE_FEATURE_TELEMEDICINE !== 'false',
    vr: env.VITE_FEATURE_VR !== 'false',
    fhir: env.VITE_FEATURE_FHIR !== 'false',
  },
};

/** Build a full API URL for a named function. */
export const api = (path) => `${config.apiBase}/${path.replace(/^\/+/, '')}`;

export default config;
